import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError } from "@nju/result";
import { IPayByLinkResult } from "./types";
import { serverResponse } from "./validators";

interface IParams {
  userId: string;
  amount: number;
}

export async function payByLink({
  userId,
  amount,
}: IParams): Promise<IPayByLinkResult> {
  const data = {
    type: "PAYMENT",
    channel: {
      id: "WEB",
      name: "WEB",
    },
    beneficiary: {
      id: userId,
      referredType: "DIGITAL_WALLET",
    },
    payer: {
      id: userId,
    },
    paymentItem: [
      {
        productOfferingId: "TopUpDigitalWallet",
        amount: {
          amount,
          currency: "pln",
        },
      },
    ],
    totalAmount: {
      amount,
      currency: "pln",
    },
    paymentMethod: {
      action: "ONE_CLICK",
      methodType: "PAY_BY_LINK",
    },
  };

  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST || "unknown"}/payment`,
    {
      method: "post",
      validator: serverResponse,
      json: data,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
